// const constants = require('../../../config/constants');
import { constants, releaseConfig } from '../../common/common.js';
const cardsAcrossWindow = constants.cardsAcrossWindow;
const xlWindowBreakpoint = constants.xlWindowBreakpoint;
// const releaseConfig = require('../../../config/releaseConstants');

export default class DesktopCarousels {

    /* eslint-disable complexity */
    static addDesktopPageBalls() {
        const desktopCarousels = document.querySelectorAll('.desktop-carousel');
        const paginations = document.querySelectorAll('.pagination');
        for (let i = 0; i < desktopCarousels.length; i++) {
            paginations[i].innerHTML = '';
            const offersInCarousel = Math.ceil(desktopCarousels[i].childElementCount);
            if (releaseConfig.carouselPaginationLNG1118 && offersInCarousel <= 3) {// eslint-disable-line no-magic-numbers
                paginations[i].classList.add('hide-balls-pagination');
                continue;
            } else {
                paginations[i].classList.remove('hide-balls-pagination');
            }
            const pagesCount = offersInCarousel / cardsAcrossWindow;
            for (let j = 0; j < pagesCount; j++) {
                paginations[i].innerHTML += '<div class="page-ball"></div>';
            }

            if (pagesCount === 1) {
                const firstPageBall = paginations[i].querySelector('.page-ball');
                if (firstPageBall) {
                    firstPageBall.classList.remove('page-ball');
                }
            }
        }
    }

    static onScrollHighlightCorrectPageBall(pagesCount, maxScrollWidth, i) {
        const desktopCarousels = document.querySelectorAll('.desktop-carousel');
        const paginations = document.querySelectorAll('.pagination');
        let pageProportion = desktopCarousels[i].scrollLeft / maxScrollWidth;
        pageProportion = pageProportion === 1 ? 0.999 : pageProportion; //eslint-disable-line no-magic-numbers
        const currentCarouselPage = Math.floor(pageProportion * pagesCount);
        const pageBalls = paginations[i].querySelectorAll('.page-ball');
        for (let j = 0; j < pagesCount; j++) {
            if (j === currentCarouselPage) {
                pageBalls[j].classList.remove('brand--light-grey');
                pageBalls[j].classList.add('brand--dark-grey');
            } else if (pageBalls[j]) {
                pageBalls[j].classList.remove('brand--dark-grey');
                pageBalls[j].classList.add('brand--light-grey');
            }
        }
    }

    static sortPageBallListeners() {
        const desktopCarousels = document.querySelectorAll('.desktop-carousel');
        for (let i = 0; i < desktopCarousels.length; i++) {
            const pagesCount = Math.ceil(desktopCarousels[i].childElementCount / cardsAcrossWindow);
            const maxScrollWidth = desktopCarousels[i].scrollWidth - desktopCarousels[i].clientWidth;
            desktopCarousels[i].removeEventListener('scroll', () => {
                DesktopCarousels.onScrollHighlightCorrectPageBall(pagesCount, maxScrollWidth, i);
            });
            desktopCarousels[i].addEventListener('scroll', () => {
                DesktopCarousels.onScrollHighlightCorrectPageBall(pagesCount, maxScrollWidth, i);
            });
        }
    }

    /* eslint-disable complexity */
    static calculatePageBalls(index) {
        const paginations = document.querySelectorAll('.pagination');
        const desktopCarousels = document.querySelectorAll('.desktop-carousel');
        const maxScrollWidth = desktopCarousels[index].scrollWidth - desktopCarousels[index].clientWidth;
        let pageProportion = desktopCarousels[index].scrollLeft / maxScrollWidth;
        pageProportion = pageProportion === 1 ? 0.999 : pageProportion; // eslint-disable-line no-magic-numbers
        const pagesCount = Math.ceil(desktopCarousels[index].childElementCount / cardsAcrossWindow);
        const currentCarouselPage = Math.floor(pageProportion * pagesCount);
        const pageBalls = paginations[index].querySelectorAll('.page-ball');
        for (let j = 0; j < pagesCount; j++) {
            if (j === currentCarouselPage) {
                pageBalls[j].classList.remove('brand--light-grey');
                pageBalls[j].classList.add('brand--dark-grey');
            } else if (pageBalls[j]) {
                pageBalls[j].classList.remove('brand--dark-grey');
                pageBalls[j].classList.add('brand--light-grey');
            }
        }

        if (pagesCount === 1) {
            const firstPageBall = pageBalls[0];
            if (firstPageBall) {
                firstPageBall.classList.remove('page-ball');
            }
        }
    }

    static setDesktopPageBallListeners() {
        const desktopCarousels = document.querySelectorAll('.desktop-carousel');
        for (let i = 0; i < desktopCarousels.length; i++) {
            desktopCarousels[i].removeEventListener('scroll', () => {
                DesktopCarousels.calculatePageBalls(i);
            });
            desktopCarousels[i].addEventListener('scroll', () => {
                DesktopCarousels.calculatePageBalls(i);
            }, false);
        }
    }

    static onMouseOverDisplayChevronsIfNotAtLimitOfCarousel(carousel, chevrons, maxScrollWidth) {
        if (window.innerWidth >= xlWindowBreakpoint && carousel.scrollLeft !== 0) {
            chevrons[0].style.display = 'block';
        } else {
            chevrons[0].style.display = 'none';
        }
        if (window.innerWidth >= xlWindowBreakpoint && carousel.scrollLeft !== maxScrollWidth) {
            chevrons[1].style.display = 'block';
        } else {
            chevrons[1].style.display = 'none';
        }
    }

    static onScrollHideChevronsAtLimits(carousel, chevrons, maxScrollWidth) {
        if (window.innerWidth >= xlWindowBreakpoint && carousel.scrollLeft !== 0) {
            chevrons[0].style.display = 'block';
        } else {
            chevrons[0].style.display = 'none';
        }
        if (window.innerWidth >= xlWindowBreakpoint && carousel.scrollLeft !== maxScrollWidth) {
            chevrons[1].style.display = 'block';
        } else {
            chevrons[1].style.display = 'none';
        }
    }

    static getWidth(element) {
        const style = window.getComputedStyle(element);
        const marginRight = parseInt(style.marginRight, 10);
        const marginLeft = parseInt(style.marginLeft, 10);
        const elementWidth = element.offsetWidth;
        return elementWidth + marginLeft + marginRight;
    }

    static calculateChevrons() {
        const desktopCarouselSections = document.querySelectorAll('.desktop-carousel-section');
        const desktopCarousels = document.querySelectorAll('.desktop-carousel');
        for (let i = 0; i < desktopCarousels.length; i++) {
            const chevrons = desktopCarouselSections[i].querySelectorAll('.desktop-carousel-section__chevron');
            const maxScrollWidth = desktopCarousels[i].scrollWidth - desktopCarousels[i].clientWidth;
            desktopCarouselSections[i].removeEventListener('mouseover', () => {
                DesktopCarousels.onMouseOverDisplayChevronsIfNotAtLimitOfCarousel(desktopCarousels[i], chevrons, maxScrollWidth);
            }, false);
            desktopCarouselSections[i].addEventListener('mouseover', () => {
                DesktopCarousels.onMouseOverDisplayChevronsIfNotAtLimitOfCarousel(desktopCarousels[i], chevrons, maxScrollWidth);
            }, false);
            desktopCarousels[i].removeEventListener('scroll', () => {
                DesktopCarousels.onScrollHideChevronsAtLimits(desktopCarousels[i], chevrons, maxScrollWidth);
            }, false);
            desktopCarousels[i].addEventListener('scroll', () => {
                DesktopCarousels.onScrollHideChevronsAtLimits(desktopCarousels[i], chevrons, maxScrollWidth);
            }, false);
            desktopCarouselSections[i].removeEventListener('mouseout', () => {
                for (let j = 0; j < chevrons.length; j++) {
                    chevrons[j].style.display = 'none';
                }
            }, false);
            desktopCarouselSections[i].addEventListener('mouseout', () => {
                for (let j = 0; j < chevrons.length; j++) {
                    chevrons[j].style.display = 'none';
                }
            }, false);
        }

        for (let i = 0; i < desktopCarousels.length; i++) {
            const desktopCarousel = desktopCarousels[i];
            const carouselWidth = DesktopCarousels.getWidth(desktopCarousel);
            const cardWidth = DesktopCarousels.getWidth(desktopCarousel.querySelector('.carousel-card'));
            const chevrons = desktopCarouselSections[i].querySelectorAll('.desktop-carousel-section__chevron');
            const scrollJump = carouselWidth < cardsAcrossWindow * cardWidth ? carouselWidth - 20 : cardsAcrossWindow * cardWidth; //eslint-disable-line no-magic-numbers
            chevrons[0].removeEventListener('click', () => {
                desktopCarousel.scrollLeft -= scrollJump;
            }, false);
            chevrons[1].removeEventListener('click', () => {
                desktopCarousel.scrollLeft += scrollJump;
            }, false);
            chevrons[0].addEventListener('click', () => {
                desktopCarousel.scrollLeft -= scrollJump;
            }, false);
            chevrons[1].addEventListener('click', () => {
                desktopCarousel.scrollLeft += scrollJump;
            }, false);
        }
    }

    static makeDesktopCarousels() {
        DesktopCarousels.addDesktopPageBalls();
        DesktopCarousels.sortPageBallListeners();
        DesktopCarousels.setDesktopPageBallListeners();
        DesktopCarousels.calculateChevrons();
    }
}
